(function () {
  'use strict';

  if (window.__eleatKlaviyoCartTracker || typeof window.fetch !== 'function') return;
  window.__eleatKlaviyoCartTracker = '2026-11-02.1';

  var originalFetch = window.fetch;
  var origin = window.location.origin;
  var rootUrl;

  try {
    rootUrl = new URL(window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/', origin);
    if (rootUrl.origin !== origin) rootUrl = new URL('/', origin);
    if (rootUrl.pathname.slice(-1) !== '/') rootUrl.pathname += '/';
  } catch (error) {
    rootUrl = new URL('/', origin);
  }

  var cartUrl = new URL('cart.js', rootUrl).href;
  var addPaths = [
    new URL('cart/add.js', rootUrl).pathname,
    new URL('cart/add', rootUrl).pathname,
    '/cart/add.js',
    '/cart/add'
  ];
  var pending = 0;
  var revision = 0;
  var dirty = false;
  var timer;
  var lastFingerprint = '';
  var lastTrackedAt = 0;

  function isCartAddition(input, options) {
    try {
      var url = new URL(typeof input === 'object' && input !== null && typeof input.url === 'string' ? input.url : input, origin);
      var method = options && options.method || input && input.method || 'GET';
      return String(method).toUpperCase() === 'POST' && url.origin === origin && addPaths.indexOf(url.pathname) !== -1;
    } catch (error) {
      return false;
    }
  }

  function validAddition(data) {
    if (!data || typeof data !== 'object' || data.errors || data.description || Number(data.status) >= 400) return false;
    var items = Array.isArray(data.items) ? data.items : [data];
    return items.some(function (line) {
      return line && (line.variant_id || line.id) && Number(line.quantity) > 0;
    });
  }

  function trackCart(data) {
    if (!data || !Array.isArray(data.items) || !data.items.length || !Number.isFinite(data.total_price) || !Number.isFinite(data.original_total_price)) return;
    var queue = window._learnq = window._learnq || [];
    if (typeof queue.push !== 'function') return;
    var fingerprint = JSON.stringify([data.total_price, data.total_discount, data.original_total_price, data.items]);
    var now = Date.now();
    if (fingerprint === lastFingerprint && now - lastTrackedAt < 10000) return;
    queue.push(['track', 'Added to Cart', {
      total_price: Number(data.total_price) / 100,
      $value: Number(data.total_price) / 100,
      total_discount: data.total_discount,
      original_total_price: Number(data.original_total_price) / 100,
      items: data.items,
      TrackerVersion: '2026-11-02.1'
    }]);
    lastFingerprint = fingerprint;
    lastTrackedAt = now;
  }

  function scheduleCart() {
    window.clearTimeout(timer);
    if (pending || !dirty) return;
    timer = window.setTimeout(function () {
      var snapshotRevision = revision;
      if (pending || !dirty) return;
      dirty = false;
      Promise.resolve().then(function () {
        return originalFetch.call(window, cartUrl, {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: {Accept: 'application/json'}
        });
      }).then(function (response) {
        return response && response.ok ? response.json() : null;
      }).then(function (data) {
        if (pending || snapshotRevision !== revision) {
          dirty = true;
          scheduleCart();
          return;
        }
        trackCart(data);
      }).catch(function () {});
    }, 1000);
  }

  function beginAddition() {
    pending += 1;
    revision += 1;
    window.clearTimeout(timer);
    var finished = false;
    return function (succeeded) {
      if (finished) return;
      finished = true;
      pending -= 1;
      if (succeeded) dirty = true;
      scheduleCart();
    };
  }

  window.fetch = function () {
    var response = originalFetch.apply(this, arguments);
    if (isCartAddition(arguments[0], arguments[1])) {
      var finish = beginAddition();
      Promise.resolve(response).then(function (result) {
        return result && result.ok ? result.clone().json() : null;
      }).then(function (data) {
        finish(validAddition(data));
      }).catch(function () {
        finish(false);
      });
    }
    return response;
  };

  if (typeof window.XMLHttpRequest !== 'function' || typeof WeakMap !== 'function') return;

  var requestDetails = new WeakMap();
  var originalOpen = window.XMLHttpRequest.prototype.open;
  var originalSend = window.XMLHttpRequest.prototype.send;

  window.XMLHttpRequest.prototype.open = function (method, url) {
    var result = originalOpen.apply(this, arguments);
    requestDetails.set(this, isCartAddition(url, {method: method}));
    return result;
  };

  window.XMLHttpRequest.prototype.send = function () {
    if (!requestDetails.get(this)) return originalSend.apply(this, arguments);
    var request = this;
    var finish = beginAddition();
    var onComplete = function () {
      var valid = false;
      try {
        if (request.status >= 200 && request.status < 300) {
          var data = request.responseType === 'json' ? request.response : JSON.parse(request.responseText);
          valid = validAddition(data);
        }
      } catch (error) {}
      finish(valid);
    };
    request.addEventListener('loadend', onComplete, {once: true});
    try {
      return originalSend.apply(this, arguments);
    } catch (error) {
      request.removeEventListener('loadend', onComplete);
      finish(false);
      throw error;
    }
  };
}());

